import { useCallback } from 'react';
import { useRecoilState } from 'recoil';
import { templateSendDialogAtom } from '../state/templateAtoms';
import { normalizeTemplate } from '../utils/normalizeTemplate';
import { isTemplateArchived } from '../utils/templateArchiveUtils';
import { useSnackBar } from '../../../components/FlowBuilder/Common/SnackBar/index.tsx';

export const TEMPLATE_SEND_DIALOG_CLOSED = { open: false, template: null };

export default function useTemplateSendDialog() {
  const { showSnackBar } = useSnackBar();
  const [sendDialog, setSendDialog] = useRecoilState(templateSendDialogAtom);

  const openSendDialog = useCallback(
    (template) => {
      if (!template?.name || !template?.bot_number) return;
      if (isTemplateArchived(template)) {
        showSnackBar('Archived templates cannot be sent', 'warning');
        return;
      }
      setSendDialog({
        open: true,
        template: normalizeTemplate(template),
      });
    },
    [setSendDialog, showSnackBar]
  );

  const closeSendDialog = useCallback(() => {
    setSendDialog(TEMPLATE_SEND_DIALOG_CLOSED);
  }, [setSendDialog]);

  return {
    open: sendDialog.open,
    template: sendDialog.template,
    openSendDialog,
    closeSendDialog,
  };
}
